import React, { useState, useEffect } from "react";
import styles from "./Invoices.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import invoiceimg from "../../assets/images/invoices.png";
import logo from "../../assets/images/logo.png";
import viewcart from "../../assets/icons/viewcart.png";
import { useAuth } from "../../context/auth";

const Invoices = () => {
  const MAIN_URL = process.env.REACT_APP_URL

  const { user = {} } = useAuth();

// TO GET ALL INVOICES
  const [invoices, setInvoices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const token = localStorage.getItem("token");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        const response = await axios.get(
          `${MAIN_URL}/api/invoice/getAllInvoices`,
          config
        );
        setInvoices(response.data);
      } catch (error) {
        console.error("Error fetching invoices:", error);
      }
    };

    fetchInvoices();
  }, []);

  const handleViewInvoice = (id) => {
    navigate(`/singleInvoice/${id}`);
  };

  return (
    <>
      <div className={styles.invoices_page}>
        <Header />
        {/* <Navbar /> */}
        <div className={styles.navbar}>
          <div className={styles.left}>
            <div className={styles.logo}>
              <img src={logo} alt="" />
              <p>Musicart</p>
            </div>
            <div className={styles.page}>Home/ Invoices</div>
          </div>
          <div className={styles.right}>
            <div className={styles.viewcart}>
              <img src={viewcart} alt="cart" />
              <button className={styles.cart_btn}>
                <NavLink
                  className={styles.navlink_page_cart_btn}
                  to="/viewcart"
                >
                  view cart
                </NavLink>
              </button>
            </div>
          </div>
        </div>
        <div className={styles.invoice_mainContainer}>
          {/* BACK BUTTON  */}
          <div className={styles.product_back_btn}>
            <NavLink to="/home">
              <button className={styles.back_btn}>Back to products</button>
            </NavLink>
          </div>

          {/* HEADING */}
          <div className={styles.main_heading}>
            <h2>My Invoices</h2>
          </div>

          {invoices.map((invoice) => (
            <div className={styles.content}>
              <div key={invoice._id} className={styles.invoice_container}>
                <div className={styles.left_section}>
                  <img src={invoiceimg} alt="invoiceimg" />
                  <div className={styles.details_section}>
                    <p className={styles.user_name}>{user.name}</p>
                    <p className={styles.user_address}>{invoice.address}</p>
                  </div>
                </div>
                <div className={styles.right_section}>
                  <button
                    onClick={() =>
                      handleViewInvoice(invoice._id, invoice.address)
                    }
                  >
                    View Invoice
                  </button>
                </div>
              </div>
              <div className={styles.line}></div>
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Invoices;
